import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppSimpleFilterSelectedValue } from '../../../../components/filters/hooks/common.hook';
import { FILTER_NAMES } from '../../../../components/filters/hooks/filter-names.constants';
import { useAppFilterSelectedValue } from '../../../../hooks/filters/use-app-filter-selected-value.hook';
import { useSwitchPar } from '../../../layout/hooks/switch-panel.hook';
export const FORCE_SELECTION_PAR = 'force-sel';
export const useAppForceSelection = (
  marketFilterId: string = FILTER_NAMES.MARKET,
) => {
  // This to force to open the Popup through query string.
  const { show, setShow } = useSwitchPar(FORCE_SELECTION_PAR, '0');

  const marketValue = useAppSimpleFilterSelectedValue(marketFilterId);
  const { selectedValue: metaCategoryValue } = useAppFilterSelectedValue(
    FILTER_NAMES.METACATEGORY,
  );
  const [enabled, setEnabled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    if (marketValue && metaCategoryValue) {
      if (
        marketValue.values.length === 0 ||
        metaCategoryValue.values.length === 0
      ) {
        setEnabled(false);
        setShowPopup(true);
      } else {
        setEnabled(true);
      }
    }
  }, [marketValue, metaCategoryValue]);
  const handleForceSelClose = useCallback(
    (show: boolean) => {
      if (enabled) {
        setShowPopup(show);
        setShow('0');
      }
    },
    [enabled, setShow],
  );

  useEffect(() => {
    if (show === '1') {
      setShowPopup(true);
    }
  }, [show]);
  const ret = useMemo(
    () => ({
      handleForceSelClose,
      enabled,
      showPopup,
    }),
    [handleForceSelClose, enabled, showPopup],
  );
  return ret;
};
